import { createElement, memo, useContext } from '@max/max';
const isWeb = true;
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './index.scss';
import { GOODS_STATUS } from '../types';
import Sensor from '@max/mbc-sensor';
import { LX_CONFIG, SHOW_TYPE_ENUM } from '../constants';
import { onGoProductDetail } from '../utils';
import Navigate from '@nibfe/mkt-navigate-api';
const { invokeJump } = Navigate;
const ShowSize = {
    [SHOW_TYPE_ENUM.SIGNAL_ROW]: 'small',
    [SHOW_TYPE_ENUM.TWO_LIST]: 'normal'
};
const ImageSize = {
    small: {
        width: '314rpx',
        height: '235rpx'
    },
    normal: {
        width: '342rpx',
        height: '256rpx'
    }
};
const MyComponent = (props) => {
    const { productIdStr, productId, headImage, positionInfo, title, price, buyButtonText, salesCount, score, rating, bookInfo, userReview, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, scoreInfoSwitch, bookInfoSwitch, distanceInfoSwitch, salesInfoSwitch, buyButtonTextColor, buyButtonBackgroundColor, status, priceColor } = props.poiInfo;
    const { showType = SHOW_TYPE_ENUM.TWO_LIST, clickBizLine, wakeupSource } = props;
    const { sellPrice, originalPrice, discountInfo } = price || {};
    const ctx = useContext(global === null || global === void 0 ? void 0 : global._EngineGlobalContext);
    const { _LXReport, _moduleId } = ctx;
    const onCardClick = () => {
        var _a, _b, _c, _d, _e, _f;
        const relProductId = productIdStr || productId;
        // const poiId = extModel.poiIdStr || extModel.poiId;
        if (!relProductId || status !== GOODS_STATUS.CAN_SALE || (window === null || window === void 0 ? void 0 : window.inEditor)) {
            return;
        }
        const val_lab = {
            _moduleId: _moduleId !== null && _moduleId !== void 0 ? _moduleId : '-999',
            poi_id: relProductId,
            tex_id: (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.pageId) !== null && _c !== void 0 ? _c : '-999',
            custom: {}
        };
        const hotelchannel = (_e = (_d = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.queryParams) === null || _e === void 0 ? void 0 : _e.hotelchannel;
        if (hotelchannel) {
            val_lab.custom.hotel_channel = hotelchannel;
        }
        if (wakeupSource) {
            val_lab.custom.wakeupSource = wakeupSource;
        }
        if (clickBizLine) {
            val_lab.custom.click_biz_line = clickBizLine;
        }
        (_f = _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReportWithTag) === null || _f === void 0 ? void 0 : _f.call(_LXReport, LX_CONFIG.CARD_MC_BID, {
            valLab: val_lab
        });
        onGoProductDetail({
            productId: relProductId,
            clickBizLine,
            hotelchannel
        });
    };
    const onCardShow = () => {
        var _a, _b, _c;
        const relProductId = productIdStr || productId;
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(LX_CONFIG.CARD_MV_BID, {
            valLab: {
                _moduleId: _moduleId !== null && _moduleId !== void 0 ? _moduleId : '-999',
                poi_id: relProductId,
                tex_id: (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.pageId) !== null && _c !== void 0 ? _c : '-999',
                click_biz_line: clickBizLine !== null && clickBizLine !== void 0 ? clickBizLine : '-999',
                wakeupSource
            }
        });
    };
    const hasSaleCount = originalPrice && sellPrice && Number(originalPrice) > Number(sellPrice);
    return <Sensor once onAppear={() => {
            onCardShow();
        }}>
      <View className={`phx-poi-lis--card-container-${ShowSize[showType]}`} style={Object.assign(Object.assign({}, props.style), (isWeb ? {
            boxShadow: '0rpx 3rpx 9rpx 0rpx rgba(0, 0, 0, 0.12)'
        } : {}))} onClick={() => {
            onCardClick();
        }}>
        {/* 上半部分，主要为头图和地标 */}
        <View className={`phx-poi-lis--top-area-${ShowSize[showType]}`}>
          <Image x-if={headImage === null || headImage === void 0 ? void 0 : headImage.value} style={ImageSize[ShowSize[showType]]} source={{
            uri: headImage.value ? headImage.value.replace('http:', 'https:').replace('/w.h/', '/') + '@684w' : ''
        }}></Image>
          <View x-if={bookInfoSwitch} className="phx-poi-lis--book-info-container">
            <Text className="phx-poi-lis--book-info">{bookInfo}</Text>
          </View>
          <View x-if={headIcon && headIconText && !headIconImg} style={{
            backgroundColor: headIconBackgroundColor
        }} className="phx-poi-lis--head-icon">
            <Text style={{
            color: headIconTextColor
        }} className="phx-poi-lis--head-icon-text">
              {headIconText}
            </Text>
          </View>
          <View x-if={headIcon && headIconImg} style={{
            backgroundColor: headIconBackgroundColor
        }} className="phx-poi-lis--head-icon-image-container">
            <Image x-if={headIconImg} className="phx-poi-lis--head-icon-image-container" source={{
            width: '150rpx',
            height: '12rpx',
            uri: headIconImg
        }}></Image>
          </View>
        </View>
        {/* 下半部分，主要为折扣、销量 */}
        <View className="phx-poi-lis--bottom-area">
          <View>
            <Text numberOfLines={2} style={{
            textOverflow: 'ellipsis'
        }} className="phx-poi-lis--poi-name">
              {title}
            </Text>
            <View className="phx-poi-lis--score-rating-user-review-container">
              <Text x-if={scoreInfoSwitch && score} className="phx-poi-lis--score">
                {score}
              </Text>
              <Text x-if={rating} className="phx-poi-lis--rating">
                {rating}
              </Text>
              <Text x-if={userReview} numberOfLines={1} className="phx-poi-lis--user-review">
                {userReview}
              </Text>
            </View>
          </View>

          <View className="phx-poi-lis--price-area">
            <Text x-if={positionInfo && distanceInfoSwitch} numberOfLines={1} className="phx-poi-lis--position-info">
              {positionInfo}
            </Text>
            <View className="phx-poi-lis--small-tag-container">
              <View x-if={discountInfo} className="phx-poi-lis--discount-container">
                <Text className="phx-poi-lis--discount-content">{discountInfo}</Text>
              </View>
              <View x-if={salesCount && salesInfoSwitch} className="phx-poi-lis--sales-count-container">
                <Text className="phx-poi-lis--sales-count-content">{salesCount}</Text>
              </View>
            </View>
            <View className="phx-poi-lis--price-wrap">
              <View className="phx-poi-lis--sell-price">
                <Text className="phx-poi-lis--prev">￥</Text>
                <Text className="phx-poi-lis--price" style={{
            color: priceColor,
            fontFamily: isWeb ? 'MTfin-bold2' : 'MTfin-bold2.0'
        }}>
                  {sellPrice}
                </Text>
                <Text className="phx-poi-lis--behind">起</Text>
              </View>

              <Text x-if={hasSaleCount} className="phx-poi-lis--origin-price">{`￥${originalPrice}`}</Text>
            </View>
            <View className="phx-poi-lis--buy-button-wrap" style={{
            backgroundColor: status === GOODS_STATUS.CAN_SALE ? buyButtonBackgroundColor : '#CCCCCC'
        }}>
              <Text className="phx-poi-lis--buy-button-text" style={{
            color: status === GOODS_STATUS.CAN_SALE ? buyButtonTextColor : '#999999'
        }}>
                {status === GOODS_STATUS.CAN_SALE ? buyButtonText : '售罄'}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Sensor>;
};
export default memo(MyComponent);
